
































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { SchoolGroupCompetencyRanking } from '@/models/school-group/school-group-competency-ranking';
import { CompetencySetting } from '@/models/competency/competency-setting';
import { studentFilterModule } from '@/store/modules/frames/student-filters.module';
import { groupModule } from '@/store/modules/entities/group.module';
import GClassManagementShowCompetencySetting from '@/views/GClassManagement/GClassManagementShowCompetencySetting.vue';
import GClassManagementCompetencyRankCard from '@/views/GClassManagement/GClassManagementCompetencyRankCard.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GClassManagementCompetencyRanking',
  components: {
    GClassManagementCompetencyRankCard,
    GClassManagementShowCompetencySetting,
  },
})
export default class GClassManagementCompetencyRanking extends mixins(GPageBase) {
  showCompetencySelectionModal: boolean = false;
  showAllCompetencyRankingModal: boolean = false;

  mounted() {}

  get competencyRankingByType(): SchoolGroupCompetencyRanking[] {
    return groupModule.competencyRankingByType;
  }

  get schoolGroupCompetency(): CompetencySetting[] {
    return groupModule.competencySettings;
  }

  get schoolGroupCompetencyRanking(): SchoolGroupCompetencyRanking[] {
    if (this.competencyRankingByType && this.schoolGroupCompetency) {
      return this.competencyRankingByType.filter((d1: SchoolGroupCompetencyRanking) => this.schoolGroupCompetency.some((d2: CompetencySetting) => d1.competencyID === d2.competencyID));
    }
  }
  get competencySelectionReRender(): string {
    if (this.schoolGroupCompetency) {
      return JSON.stringify(this.schoolGroupCompetency);
    }
  }

  get isAllGradeAndAllSchoolClassSearch(): boolean {
    return studentFilterModule.grade === 0 && studentFilterModule.schoolClassID === 0;
  }

  get targetType(): GEnum.TargetType {
    return studentFilterModule.targetType;
  }

  get targetID(): number {
    return studentFilterModule.targetID;
  }

  handleCompetencySelectionModal(): void {
    this.showCompetencySelectionModal = true;
  }

  handleCompetencySelectionModalClose(): void {
    this.showCompetencySelectionModal = false;
  }

  handleCloseRankingModal(): void {
    this.showAllCompetencyRankingModal = false;
  }

  handleModalClose(value: boolean): void {
    this.showCompetencySelectionModal = value;
  }

  goToCompetencyRankingDetails(): void {
    this.showAllCompetencyRankingModal = true;
  }
}
